import { useDeviceType } from '@cian/ui-kit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { STONE_3SP_DESKTOP_EXPERIMENT_ENABLED_KEY } from '../../../constants/config';
import { STONE_BANNER } from '../../../constants/stone';
import { ExpStone3SPDesktop } from '../../../experiments/declarations';
import { selectMapBounds } from '../../../selectors/mapBounds';
import { selectParentRegionId } from '../../../selectors/parentRegionId';
import { selectJsonQuery } from '../../../selectors/results';
import { TAdfoxMapBannerConfig, TAdfoxMapBannerConfigItem } from '../../../types/adfoxMapBannerConfig';
import { IApplicationState } from '../../../types/redux';
import { getAdfoxBannerConfig } from '../../../utils/bannerPackages';
import { useApplicationContext } from '../../ApplicationContext';

export function useSelectedAdfoxBannerConfig(): TAdfoxMapBannerConfigItem | null {
  const deviceType = useDeviceType();
  const jsonQuery = useSelector(selectJsonQuery);
  const { zoom } = useSelector(selectMapBounds);
  const adfoxMapBannerConfig = useSelector((state: IApplicationState) => state.config.adfoxMapBannerConfig);
  const parentRegionId = useSelector(selectParentRegionId);
  const { config } = useApplicationContext();

  /**
   * Баннер Stone показываем всем, пока фичатоггл Martech.Stone3SPDesktopExperiment.Enabled выключен,
   * а при включённом — только группе B эксперимента (при выключенном он не запрашивается).
   */
  const stoneExperimentGroup = ExpStone3SPDesktop.use();
  const isStoneExperimentAllowed =
    !config.get<boolean>(STONE_3SP_DESKTOP_EXPERIMENT_ENABLED_KEY) || stoneExperimentGroup === 'B';

  const adfoxEnabled = config.get<boolean>('mapSearchFrontend.AdfoxMapBanner.Enabled') || false;

  const filteredConfig = useMemo<TAdfoxMapBannerConfig>(() => {
    return adfoxMapBannerConfig.filter(item => {
      if (item.developerId === STONE_BANNER.developerId) {
        return isStoneExperimentAllowed;
      }

      return true;
    });
  }, [adfoxMapBannerConfig, isStoneExperimentAllowed]);

  return getAdfoxBannerConfig({
    zoom,
    jsonQuery,
    deviceType,
    adfoxEnabled,
    adfoxMapBannerConfig: filteredConfig,
    parentRegionId,
  });
}
